'use strict'

const getPopoverLocation = (position, alignment, horizontalOffset, verticalOffset) => {
    const location = {}

    switch (position) {
        case 'left':
            location.right = `calc(100% - ${horizontalOffset}px)`
            break
        case 'right':
            location.left = `calc(100% + ${horizontalOffset}px)`
            break
        case 'top':
            location.bottom = `calc(100% + ${verticalOffset}px)`
            break
        case 'bottom':
            location.top = `calc(100% - ${verticalOffset}px)`
            break
    }

    switch (position) {
        case 'left':
        case 'right':
            switch (alignment) {
                case 'start':
                    location.top = -1 * verticalOffset
                    break
                case 'center':
                    location.top = `calc(50% - ${verticalOffset}px)`
                    location.transform = 'translateY(-50%)'
                    break
                case 'end':
                    location.bottom = -1 * verticalOffset
            }
            break

        case 'top':
        case 'bottom':
            switch (alignment) {
                case 'start':
                    location.left = horizontalOffset
                    break
                case 'center':
                    location.left = `calc(50% + ${horizontalOffset}px)`
                    location.transform = 'translateX(-50%)'
                    break
                case 'end':
                    location.right = horizontalOffset
                    break
            }
            break
    }

    return location
}

module.exports = getPopoverLocation